import React, { useState } from 'react';
import SideMenu from '../admin/SideMenu';


const AdminHome = () => {
  const [isMenuOpen, setMenuOpen] = useState(true); // State to track menu visibility

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen); // Toggle menu state
  };

  return (
    <div className="d-flex">
     <SideMenu />

      {/* Main Content Area */}
      <div id="page-content-wrapper" style={{ flex: 1, padding: '20px' }}>

        <div className="container-fluid">
          <h1 className="mt-4">Welcome To The Admin Section</h1>
          <p>You can configure and manage the different data and view the applications from here.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminHome;
